"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _components = require("../../components");

var _Button = require("../components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _SensitiveOverlay = require("../components/SensitiveOverlay");

var _SensitiveOverlay2 = _interopRequireDefault(_SensitiveOverlay);

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

var _auth = require("../../redux/modules/auth");

var auth = _interopRequireWildcard(_auth);

var _user = require("../../redux/modules/user");

var _selectors = require("../../EpicMigration/selectors");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MixerTermsPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(MixerTermsPopup, _React$Component);

  function MixerTermsPopup(props) {
    (0, _classCallCheck3.default)(this, MixerTermsPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MixerTermsPopup.__proto__ || (0, _getPrototypeOf2.default)(MixerTermsPopup)).call(this, props));

    _this.handleCheck = _this.handleCheck.bind(_this);
    _this.handleAcceptEULA = _this.handleAcceptEULA.bind(_this);

    _this.state = {
      checked: false
    };
    return _this;
  }

  (0, _createClass3.default)(MixerTermsPopup, [{
    key: "handleAcceptEULA",
    value: function handleAcceptEULA() {
      var _this2 = this;

      var _props = this.props,
          acceptMixerEULA = _props.acceptMixerEULA,
          loadUser = _props.loadUser,
          studioUrl = _props.studioUrl;


      this.setState({
        accepting: true
      });

      acceptMixerEULA().then(function () {
        _this2.setState({
          accepting: false,
          accepted: true
        }, function () {
          loadUser().then(function () {
            window.location.href = studioUrl;
            _this2.props.onCloseNo();
          }).catch(function () {
            _this2.props.onCloseNo();
          });
        });
      }).catch(function (error) {
        _this2.setState({
          accepting: false,
          accepted: false,
          acceptError: error
        });
      });
    }
  }, {
    key: "handleCheck",
    value: function handleCheck(ev) {
      var currentTarget = ev.currentTarget;
      var checked = currentTarget.checked;


      this.setState({ checked: checked });
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          accepting = _props2.accepting,
          acceptError = _props2.acceptError,
          newUser = _props2.newUser,
          updateEULA = _props2.updateEULA,
          isStudioOrCustomPlan = _props2.isStudioOrCustomPlan;
      var _state = this.state,
          checked = _state.checked,
          accepted = _state.accepted;


      return _react2.default.createElement(
        _components.Popup,
        null,
        _react2.default.createElement(
          _components.Popup.Header,
          null,
          "Terms of service"
        ),
        _react2.default.createElement(
          _components.Popup.Content,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.container },
            _react2.default.createElement(
              "p",
              null,
              "To download and use Mixer you must review and accept the",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { href: "https://legal.epicgames.com/en-US/epicgames/mixer", target: "_blank", rel: "noopener noreferrer" },
                "Mixer Supplemental Terms."
              ),
              " ",
              "These terms apply to your offline use of the app."
            ),
            _react2.default.createElement(
              "label",
              { className: _styles2.default.checkboxLabel },
              _react2.default.createElement(_Checkbox2.default, { name: "eula", checked: checked, onChange: this.handleCheck }),
              _react2.default.createElement(
                "span",
                null,
                "I have read and agree to the",
                " ",
                _react2.default.createElement(
                  _reactRouter.Link,
                  { href: "https://legal.epicgames.com/en-US/epicgames/mixer", target: "_blank", rel: "noopener noreferrer" },
                  "Mixer Supplemental Terms."
                ),
                " "
              )
            ),
            acceptError ? _react2.default.createElement(
              "p",
              { className: _styles2.default.error },
              "Something went wrong. Please try again in a short while or",
              " ",
              _react2.default.createElement(
                _reactRouter.Link,
                { to: _config2.default.forumBaseUrl, target: "_blank", rel: "noopener noreferrer" },
                "Contact Support."
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          _components.Popup.Footer,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.footer },
            _react2.default.createElement(_Button2.default, {
              loading: accepting,
              className: _styles2.default.button,
              disabled: !checked,
              primary: true,
              small: true,
              smallSize: true,
              label: "Continue",
              onClick: this.handleAcceptEULA
            })
          )
        )
      );
    }
  }]);
  return MixerTermsPopup;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    isLoading: (0, _selectors.selectIsLoading)(state),
    isEpicLogin: (0, _selectors.selectIsEpicLogin)(state),
    isStudioOrCustomPlan: (0, _selectors.isStudioOrCustomPlan)(state)
  };
}, {
  acceptMixerEULA: auth.acceptMixerEULA,
  loadUser: _user.load
})(MixerTermsPopup);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/MixerTermsPopup/index.jsx
// module id = 648
// module chunks = 0